// extracted by mini-css-extract-plugin
export default {"viaAdmin":"RowPharmacy_viaAdmin__M+gmr"};